"use strict";
/*
 * Servicio de Administración Tributaria, 2021
 *
 * Autor(es):
 *  -> Carlos Gerardo Malanche Flores <carlos.malanche@sat.gob.mx>
 *
 * El contenido de este archivo sigue las reglas establecidas en la licencia
 * de la biblioteca de código, situada en la raíz del proyecto bajo el
 * nombre LICENSE.md.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = exports.isBoolean = exports.isNumber = exports.isString = exports.isError = void 0;
/**
 * Función auxiliar para determinar si un objeto es una instancia de {@link CSError | Error}
 *
 * @param candidate Candidato a ser un {@link cs.Error }
 * @returns Un predicado de tipo {@link cs.Error}
 *
 * ```typescript
 * import * as cs from 'cryptosat-ts';
 *
 * let sm = cs.SecureMap.from_string('{"hello": "world"}');
 *
 * if(cs.utils.isError(sm)) {
 *     // Lidiamos con el error aquí
 *     // ...
 * } else {
 *     // En este caso, lidiamos con el mapa seguro.
 *     // ..
 * }
 * ```
 */
function isError(candidate) {
    return candidate.__code !== undefined && candidate.__code !== undefined;
}
exports.isError = isError;
/**
 * Función auxiliar para determinar si un objeto es una instancia de {@link string | string}
 *
 * @param candidate Candidato a ser un {@link string | string}
 * @returns Un predicado de tipo {@link string | string}
 *
 * ```typescript
 * import * as cs from 'cryptosat-ts';
 *
 * let candidate: number | string = 10;
 *
 * if(cs.utils.isString(candidate)) {
 *     // Sí es una cadena
 *     // ...
 * } else {
 *     // No es una cadena
 *     // ...
 * }
 * ```
 */
function isString(candidate) {
    return (typeof (candidate) === "string");
}
exports.isString = isString;
/**
 * Función auxiliar para determinar si un objeto es una instancia de {@link number | number}
 *
 * @param candidate Candidato a ser un {@link number | number}
 * @returns Un predicado de tipo {@link number | number}
 *
 * ```typescript
 * import * as cs from 'cryptosat-ts';
 *
 * let candidate: Date | number = new Date();
 *
 * if(cs.utils.isNumber(candidate)) {
 *     // Sí es un número
 *     // ...
 * } else {
 *     // No es un número
 *     // ...
 * }
 * ```
 */
function isNumber(candidate) {
    return (typeof (candidate) === "number");
}
exports.isNumber = isNumber;
/**
 * Función auxiliar para determinar si un objeto es una instancia de {@link boolean | boolean}
 *
 * @param candidate Candidato a ser un {@link boolean | boolean}
 * @returns Un predicado de tipo {@link boolean | boolean}
 *
 * ```typescript
 * import * as cs from 'cryptosat-ts';
 *
 * let candidate: number | boolean = true;
 *
 * if(cs.utils.isBoolean(candidate)) {
 *     // Sí es un booleano
 *     // ...
 * } else {
 *     // No es un booleano
 *     // ...
 * }
 * ```
 */
function isBoolean(candidate) {
    return (typeof (candidate) === "boolean");
}
exports.isBoolean = isBoolean;
/**
 * Función auxiliar para determinar si un objeto es una instancia de {@link Array<JsonValue> | Array}
 *
 * @param candidate Candidato a ser un {@link Array<JsonValue> | Array}
 * @returns Un predicado de tipo {@link Array<JsonValue> | Array}
 *
 * ```typescript
 * import * as cs from 'cryptosat-ts';
 *
 * let candidate: Date | Array<number> = new Array(1, 2, 3);
 *
 * if(cs.utils.isArray(candidate)) {
 *     // Sí es un arreglo
 *     // ...
 * } else {
 *     // No es un arreglo
 *     // ...
 * }
 * ```
 */
function isArray(candidate) {
    return Array.isArray(candidate);
}
exports.isArray = isArray;
//# sourceMappingURL=predicates.js.map